// Module
var code = "<li> <!-- ko if: _children.length > 0 --> <ul> <!-- ko foreach: _children--> <!-- ko template: {name: $data.GetTemplateName.bind($data), afterRender: $data.AfterRender.bind($data)} --> <!-- /ko --> <!-- /ko --> </ul> <!-- /ko --> </li>";
// Exports
export default code;